import Vue from 'vue'

// 手写签名
import signatureH5 from '@jensonhui/signature-h5'
import '@jensonhui/signature-h5/lib/signatureH5.css'

Vue.config.productionTip = false
Vue.use(signatureH5)
